import color, { hue } from "./helpers.js";
import {} from "d3";
import { hsluv } from "../color/hsluv.js";
import lineInterpolationFactory from './interpolate-hsl-as-lab.js';
const interpolatorFactory = (hueInterpolator) => {
    return (a, b) => {
        const _a = hsluv(a);
        const _b = hsluv(b);
        const h = hueInterpolator(_a.h, _b.h);
        const s = color(_a.s, _b.s);
        const l = color(_a.l, _b.l);
        const opacity = color(_a.opacity, _b.opacity);
        return (t) => {
            _a.h = h(t);
            _a.s = s(t);
            _a.l = l(t);
            _a.opacity = opacity(t);
            return _a.toString();
        };
    };
};
export const interpolateHsluv = interpolatorFactory(hue);
export const interpolateHsluvLong = interpolatorFactory(color);
export const interpolateHsluvLine = lineInterpolationFactory(hsluv);
